<template>
    <div>
        <v-layout column class="subheading">
            <div class="text-h6 mb-3" data-testid="plan-header">
                {{ monthText }} Month Total Balance for Unit {{ unit.unit_name }}
            </div>
            <v-layout class="mb-1" data-testid="plan-rent">
                <v-flex xs4>Current Balance:</v-flex>
                <v-flex
                    xs2
                    class="text-right"
                >${{ unit.total_amount_due ? unit.total_amount_due.toFixed(2) : '?' }}</v-flex>
            </v-layout>
            <v-divider class="mt-2 mb-3" style="width: 15vw" />
            <v-layout class="pb-4 text-h6 font-weight-regular" data-testid="plan-total">
                <v-flex xs4>Monthly Payment:</v-flex>
                <v-flex xs2 class="text-right" v-if="monthlyCost">${{ monthlyCost.toFixed(2) }}</v-flex>
            </v-layout>
        </v-layout>
    </div>

</template>

<script>
export default {
  name: "PaymentBreakdown",
  props: {
    months: {
      type: Number
    },
    unit: {
      type: Object
    },
    monthlyCost: {
      type: Number
    }
  },
  computed: {
    monthText() {
      return this.months === 2 ? "Two" : "Three";
    }
  }
};
</script>
